<mat-table class="customized-table" #table [dataSource]="dataSource" matSortActive="lastName" matSortDirection="asc" automation-id="table-staff-table" matSort>

  <!-- First Name -->
  <ng-container matColumnDef="firstname">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      FIRST NAME *
    </mat-header-cell>
    <mat-cell *matCellDef="let row">
      {{ row.firstname }}
    </mat-cell>
    <mat-footer-cell *matFooterCellDef>
      <span class="footer-cell"></span>
    </mat-footer-cell>
  </ng-container>

  <!-- Last Name -->
  <ng-container matColumnDef="lastname">
    <mat-header-cell *matHeaderCellDef mat-sort-header>
      LAST NAME *
    </mat-header-cell>
    <mat-cell *matCellDef="let row">
      {{ row.lastname }}
    </mat-cell>
    <mat-footer-cell *matFooterCellDef>
      <span class="footer-cell"></span>
    </mat-footer-cell>
  </ng-container>

  <!-- Phone -->
  <ng-container matColumnDef="phonenumber">
    <mat-header-cell *matHeaderCellDef>
      MOBILE NUMBER *
    </mat-header-cell>
    <mat-cell *matCellDef="let row">{{ row.phonenumber | mask: '(000) 000-0000' }}</mat-cell>
    <mat-footer-cell *matFooterCellDef>
      <span class="footer-cell"></span>
    </mat-footer-cell>
  </ng-container>

  <!-- Staff type -->
  <ng-container matColumnDef="stafftype">
    <mat-header-cell *matHeaderCellDef>
      STAFF TYPE *
    </mat-header-cell>
    <mat-cell *matCellDef="let row">{{ row.stafftype}}</mat-cell>
    <mat-footer-cell *matFooterCellDef>
      <span class="footer-cell"></span>
    </mat-footer-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="['firstname', 'lastname', 'phonenumber','stafftype']; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: ['firstname', 'lastname', 'phonenumber','stafftype'];" class="no-border-bottom"></mat-row>
</mat-table>